import { css } from '@emotion/react'
import { CornerMods } from '../primitives/modifiers/shape/corners'
import { SizeMods } from '../primitives/modifiers/size'

export const circle = (diameter: string) => css`
	${SizeMods({ width: diameter, height: diameter })};
	${CornerMods.FullyRounded}
`
